import { ScoreInfoType } from '../constants-types/Enums';

export class PositionPattern {
    pattern: Pattern;
}

export class CustomPatternTitle {
    self: string;
    selfConcept: string;
    synthesis: string;
    personName?: string;
    constructor(startingValues?: any) {
        Object.assign(this, startingValues);
    }
}

// TODO there seems to be some overlap with Pattern.datatransform, but there
// is enough difference that I have let the two versions co-exist

// TODO there is duplicate data here in terms of the FullPattern having a
// 'self' pattern and the pattern knowing it is a 'self' pattern. Various
// techniques could alleviate this, but leaving it to a later date
export class FullPattern {
    self: Pattern;
    selfConcept?: Pattern;
    synthesis?: Pattern;
    scoreId?: string;
    customTitle: CustomPatternTitle;

    constructor(startingValues?: any) {
        if (startingValues) {
            this.self = new Pattern(startingValues.self);
            this.self.type = ScoreInfoType.Self;
            if (startingValues.selfConcept) {
                this.selfConcept = new Pattern(startingValues.selfConcept);
                this.selfConcept.type = ScoreInfoType.SelfConcept;
            }
            if (startingValues.synthesis) {
                this.synthesis = new Pattern(startingValues.synthesis);
                this.synthesis.type = ScoreInfoType.Synthesis;
            }
            if (startingValues.customTitle) {
                this.customTitle = new CustomPatternTitle(
                    startingValues.customTitle
                );
            }
            this.scoreId = startingValues.scoreId;
        }
    }
}

export class Pattern {
    _type?: ScoreInfoType;
    A: number;
    B: number;
    C: number;
    D: number;
    M?: number;
    E?: number;

    constructor(startingValues?: any) {
        Object.assign(this, startingValues);
    }

    get type(): ScoreInfoType {
        return this._type;
    }

    set type(type: ScoreInfoType) {
        this._type = type;
        // Enforce null E except for synthesis since the server is sometimes
        // giving E for patterns it shouldn't
        if (type !== ScoreInfoType.Synthesis) {
            this.E = null;
        }
    }
}
